import { Link } from '@reach/router';
import styled, { css } from 'styled-components/macro';
import RoundProfileImage from '../../common/ProfileImage';
import {
  focusRing,
  fontSize,
  fontWeight,
  layout,
  lineHeight,
  neutral,
  radius,
  shadow,
  space,
  transition,
} from '../../../theme/tokens';

export const MessagePreview = styled.li`
  list-style: none;
  background: ${neutral.surface};
  border: 1px solid ${neutral.border};
  border-radius: ${radius.lg};
  margin: 0;
  box-shadow: ${shadow.sm};
  transition: box-shadow ${transition.fast}, border-color ${transition.fast};
  &:hover {
    box-shadow: ${shadow.md};
    border-color: ${neutral.borderStrong};
  }
  ${({ isStaff }) =>
    isStaff &&
    css`
      border-color: ${({ theme }) => theme.classroomHighlight};
      &:hover {
        border-color: ${({ theme }) => theme.classroomHighlight};
      }
      ${ParticipantProfileImage} {
        border: 3px solid ${({ theme }) => theme.classroomHighlight};
        border-radius: 50%;
      }
    `}
`;

export const MessagePreviewLink = styled(Link)`
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  grid-template-areas:
    'image participant created-at'
    'image text text';
  align-items: center;
  column-gap: ${space[3]};
  row-gap: ${space[1]};
  min-height: ${layout.touchTarget};
  padding: ${space[3]} ${space[4]};
  border-radius: inherit;
  text-decoration: none;
  width: 100%;
  ${focusRing}
`;

export const ParticipantProfileImage = styled(RoundProfileImage)`
  grid-area: image;
  align-self: center;
  justify-self: center;
  /* avatar size */
  height: 4.8rem;
  width: 4.8rem;
`;

export const MessagePreviewCreatedAt = styled.p`
  grid-area: created-at;
  align-self: baseline;
  justify-self: end;
  font-size: ${fontSize.xs};
  line-height: ${lineHeight.tight};
  color: ${neutral.textMuted};
  white-space: nowrap;
  margin: 0;
`;

export const ParticipantDisplayName = styled.p`
  grid-area: participant;
  align-self: baseline;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.bold};
  line-height: ${lineHeight.tight};
  color: ${({ theme }) => theme.headerColour};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TextPreview = styled.p`
  grid-area: text;
  align-self: start;
  font-size: ${fontSize.sm};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.textDark};
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export * from '../../common/elements/Notifications';
